import { Validate } from "./validate";
import gainsightConfig from "@/config/gainsight.config";

/**
 * Import script tag
 * @param {String} key
 */
function GainSightPX(key) {
  // Default giansightpx snippet
  (function(n, t, a, e, co) {
    let i = "aptrinsic";
    (n[i] =
      n[i] ||
      function() {
        (n[i].q = n[i].q || []).push(arguments);
      }),
      (n[i].p = e);
    n[i].c = co;
    let r = t.createElement("script");
    (r.async = !0), (r.src = a + "?a=" + e);
    let c = t.getElementsByTagName("script")[0];
    c.parentNode.insertBefore(r, c);
  })(window, document, "https://web-sdk.aptrinsic.com/api/aptrinsic.js", key);
}

/**
 * Initialize
 * @param {Object} options
 */
function init(options) {
  try {
    const { key } = options;
    if (Validate.options(options)) {
      // eslint-disable-next-line no-new
      GainSightPX(key);
      return window.aptrinsic;
    } else {
      console.log(
        "%c 🔥 GainSightPX Tracking Disabled 🔥",
        "color: #fff; background: #35495d; font-size: 14px; border-radius: 5px; padding: 10px 5px; margin: 20px 0;"
      );
      return false;
    }
  } catch {
    return false;
  }
}

export default {
  install() {
    init(gainsightConfig);
  },
};
